import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ConfigurationStore from '../stores/ConfigurationStore';
import { AllStores } from '../stores';
import { CreateModalTrigger } from '../components/CreateModalTrigger';
import { OrganizationFields } from '../components/OrganizationFields';
import { OrganizationList } from '../components/OrganizationList';
import OrganizationStore from '../stores/OrganizationStore';

type OrganizationsProps = {
    organizationStore : OrganizationStore;
    configurationStore : ConfigurationStore;
}

@inject((allStores: AllStores) => {
    return {
        organizationStore: allStores.organizationStore as OrganizationStore,
        configurationStore: allStores.configurationStore as ConfigurationStore
    };
})
@observer
class Organizations extends Component<OrganizationsProps> {

    componentDidMount() {
        this.props.organizationStore.getOrganizations();
        this.props.organizationStore.setCurrentOrganization();
    }

    render() {
        const { organizationStore, configurationStore } = this.props;
        const { organizations, createOrganization } = organizationStore;
        return (
            <form className="organizations">
                <h1>
                    Organizations &nbsp;
                    <CreateModalTrigger triggerText='Create new organization' title='Create new organization' render={({toggle} : any) =>
                        <OrganizationFields buttonText='Create organization' onSubmit={createOrganization} configurationStore={configurationStore} organizationStore={organizationStore} closeModal={toggle} />
                    }
                    />
                </h1>
                <hr/>
               <OrganizationList organizations={organizations}/>
            </form>
        );
    }
}


export { Organizations };